// src/APIs/messageService.js
/**
 * Send a message.
 * FE only sends recipient + content.
 * Sender is derived from JWT.
 *
 * Patient → Provider:
 *   { recipientProviderId, content }
 *
 * Provider → Patient:
 *   { recipientPatientId, content }
 */

// src/APIs/messageService.js
import api from "./axios";

const BASE_PATH = "/api/v1/messages";

/**
 * Send a message.
 * FE only sends recipient + content.
 * Sender is derived from JWT.
 *
 * Patient → Provider:
 *   { recipientProviderId, content }
 *
 * Provider → Patient:
 *   { recipientPatientId, content }
 */
export const sendMessage = async (payload) => {
  const res = await api.post(BASE_PATH, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

/**
 * Get messages for the authenticated patient.
 * (BE derives patientId from JWT)
 */
export const getMessagesForPatient = async () => {
  const res = await api.get(`${BASE_PATH}/patient`);
  return res.data;
};

/**
 * Get messages for the authenticated provider.
 * (BE derives providerId from JWT)
 */
export const getMessagesForProvider = async () => {
  const res = await api.get(`${BASE_PATH}/provider`);
  return res.data;
};

/** Mark message as read */
export const markMessageAsRead = async (messageId) => {
  await api.post(`${BASE_PATH}/${messageId}/read`);
};

/**
 * Delete a message
 * BE determines who is deleting based on JWT.
 */
export const deleteMessage = async (messageId) => {
  await api.delete(`${BASE_PATH}/${messageId}`);
};

/**
 * Get a thread:
 *   PATIENT → pass providerId only
 *   PROVIDER → pass patientId only
 *
 * BE determines caller identity from JWT.
 */
export const getThread = async ({ providerId, patientId, afterId, limit }) => {
  const params = {};
  if (providerId != null) params.providerId = providerId;
  if (patientId != null) params.patientId = patientId;
  if (afterId != null) params.afterId = afterId;
  if (limit != null) params.limit = limit;

  const res = await api.get(`${BASE_PATH}/thread`, { params });
  return res.data;
};
